import React from "react";
import { FilesEmptyIcon } from "@fluentui/react-icons-northstar";
import { Button } from "@fluentui/react-northstar";
import { observer } from "mobx-react-lite";
import PropTypes from "prop-types";

const CopyButton = observer((props) => {
  const { content } = props;


  const onClickHandler = () => {
    const input = document.createElement('input'); // create a text input field
    document.body.appendChild(input); // add it to the page (this may not be needed)
    input.value = content; // set the value to the value you need to add to the clipboard
    input.focus(); // focus on the input field
    input.select(); // select the content
    const result = document.execCommand('copy'); // trigger clipboard copy
    if (!result) {
      console.error('Failed to copy text.');
    }
    input.remove(); //visually remove input box
  }

  return (
    <Button
      text iconOnly
      data-testid={"copyButton"}
      className= "copy-button"
      icon={<FilesEmptyIcon />}
      onClick={onClickHandler}
    />
  );
});

CopyButton.propTypes = {
  content: PropTypes.string,
};

CopyButton.defaultProps = {
  content: "",
};


export default CopyButton;